import { createConsumer } from "@rails/actioncable";
import { HOST } from "../utils/constants/paths";

let consumer = null;

export function getConsumer() {
    if (consumer) return consumer;

    const token = localStorage.getItem("token");
    if (!token) return null;

    // Extract raw JWT from "Bearer xxx" format
    const jwt = token.startsWith("Bearer ") ? token.slice(7) : token;
    const wsUrl = HOST.replace(/^http/, "ws") + `/cable?token=${encodeURIComponent(jwt)}`;

    consumer = createConsumer(wsUrl);
    return consumer;
}

export function disconnectCable() {
    if (consumer) {
        consumer.disconnect();
        consumer = null;
    }
}
